<div class="ai-disclaimer-modal modal-content">
  <div class="modal-header">
    <h1 class="modal-title h4 fw-semibold mb-0">
      {{ '::AiDisclaimerModalTitle' | abpLocalization }}
    </h1>
  </div>

  <div class="modal-body px-3 px-md-4 py-3">
    <div class="section w-100">
      <h5 class="h5 fw-semibold text-body mb-2">
        {{ '::AiDisclaimerModalSubTitle1' | abpLocalization }}
      </h5>
      <p class="text-body-secondary fs-6 lh-lg mb-2 w-100">
        {{ '::AiDisclaimerModalSubConent1' | abpLocalization }}
      </p>
      <p class="text-body-secondary fs-6 lh-lg mb-0 w-100">
        {{ '::AiDisclaimerModalSubConent2' | abpLocalization }}
      </p>
    </div>

    <div class="section w-100">
      <h6 class="h6 fw-semibold text-body mb-2 fs-6">
        {{ '::AiDisclaimerModalSubTitle2' | abpLocalization }}
      </h6>
      <p class="text-body-secondary fs-6 lh-lg mb-0 w-100">
        {{ '::AiDisclaimerModalSubConent3' | abpLocalization }}
      </p>
    </div>

    <div class="section w-100">
      <h6 class="h6 fw-semibold text-body mb-2 fs-6">
        {{ '::AiDisclaimerModalSubTitle3' | abpLocalization }}
      </h6>
      <p
        class="text-body-secondary fs-6 lh-lg mb-0 w-100"
        innerHtml="{{ '::AiDisclaimerModalSubConent4' | abpLocalization }}"></p>
    </div>
  </div>

  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-primary" (click)="close()">
      {{ '::Close' | abpLocalization }}
    </button>
  </div>
</div>
